import React from "react";

export default function BtnView({id}) {
    return <a className="btn-flat btn-view" req-id={id}>
        <i className="material-icons">search</i>
    </a>
}
